<template>
    <el-drawer
        :title="$t('coupon-code.privilege-branch')"
        :visible.sync="drawer"
        direction="btt"
        :show-close="false"
        :before-close="handleClose"
        class="privilege-branch"
        size="50%">
        <ul class="bullet-list">
            <li v-for="item in branchList" :key="item.branchId">{{item.name}}</li>
        </ul>
    </el-drawer>
</template>

<script>
export default {
    props: {
        drawer: {
            type: Boolean,
        },
        closeDrawer: {
            type: Function,
            default: () => {}
        },
        branchList: {
            type: Array,
        },
    },
    methods: {
        handleClose(done) {
            this.closeDrawer()
        },
    }
}
</script>

<style>
    .privilege-branch .el-drawer__header {
        font-size: 24px;
        color: #000000;
        margin-bottom: 0px;
    }

    .privilege-branch .el-drawer {
        border-radius: 16px 16px 0px 0px;
        margin: auto;
        max-width: var(--max-width-app);
    }

    .privilege-branch .bullet-list {
        color: #333333;
        font-size: 20px;
    }
</style>